import React, { useEffect, useState } from 'react';
import { FieldArrayRenderProps } from 'formik';
import { Button } from 'react-bootstrap';
import Text from 'common/components/Text/Text';
import { CommonHash } from 'app/types';
import styles from '../LandingForm.module.scss';
import DatePicker from 'react-datepicker';
import TimezoneSelect from 'react-timezone-select';
import ImageElement from '../ComponentTypesForms/ImageElement';

interface SubComponentFormProps {
  landing_component: CommonHash;
  index: number;
  name: string;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  arrayHelpers: FieldArrayRenderProps;
  limit: number;
}

const WebinarForm = ({
  landing_component,
  index,
  name,
  handleChange,
  arrayHelpers,
  limit,
}: SubComponentFormProps): React.ReactElement => {
  const [webinarDate, setWebinarDate] = useState<Date | null>(
    new Date(landing_component.sub_landing_components[index].config.datetime || new Date())
  );
  const [webinarDateTimeZone, setWebinarDateTimeZone] = useState<CommonHash>({
    label: landing_component.sub_landing_components[index].config.datetime_timezone || '',
    value: landing_component.sub_landing_components[index].config.datetime_timezone || '',
  });

  useEffect(() => {
    handleChange({
      target: {
        name: `${name}[${index}].config['datetime']`,
        value: webinarDate,
      },
    });
  }, [webinarDate]);

  useEffect(() => {
    handleChange({
      target: {
        name: `${name}[${index}].config['datetime_timezone']`,
        value: webinarDateTimeZone.label,
      },
    });
  }, [webinarDateTimeZone]);
  return (
    <>
      <Text size={22}> Webinar {index + 1} </Text>
      <div className="d-flex flex-column gap-3 mt-2">
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['webinar_title']`}>Webinar Title</label>
          <input
            name={`${name}[${index}].config['webinar_title']`}
            placeholder="Webinar title"
            onChange={handleChange}
            value={landing_component.sub_landing_components[index].config.webinar_title || ''}
          />
        </div>
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['datetime']`}>Webinar Datetime</label>
          <DatePicker
            id={`${name}[${index}].config['datetime']`}
            name={`${name}[${index}].config['datetime']`}
            selected={webinarDate}
            onChange={(date) => setWebinarDate(date)}
            showTimeSelect
            timeIntervals={15}
            dateFormat="MMMM d, yyyy h:mm aa"
          />
        </div>
        <label htmlFor={`${name}[${index}].config['datetime_timezone']`}>Datetime timezone</label>
        <TimezoneSelect
          value={webinarDateTimeZone.value}
          onChange={(selectedTimezone: any) => {
            setWebinarDateTimeZone({
              label: selectedTimezone.label,
              value: selectedTimezone.value,
            });
          }}
        />
        <ImageElement
          component={landing_component.sub_landing_components[index]}
          name={`${name}[${index}]`}
          handleChange={handleChange}
        />
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['webinar_description']`}>
            Webinar description
          </label>
          <input
            name={`${name}[${index}].config['webinar_description']`}
            placeholder="Webinar description"
            onChange={handleChange}
            value={landing_component.sub_landing_components[index].config.webinar_description || ''}
          />
        </div>
        <div className={styles.group}>
          <label htmlFor={`${name}[${index}].config['webinar_link']`}>Webinar link</label>
          <input
            name={`${name}[${index}].config['webinar_link']`}
            placeholder="Webinar link"
            onChange={handleChange}
            value={landing_component.sub_landing_components[index].config.webinar_link || ''}
          />
        </div>
        <Button
          type="button"
          variant="danger"
          className={styles.deleteButton}
          onClick={() => {
            arrayHelpers.remove(index);
          }}
        >
          Delete
        </Button>
      </div>
      {index === landing_component.sub_landing_components.length - 1 &&
        landing_component.sub_landing_components.length <= limit - 1 && (
          <Button
            type="button"
            className="mt-3"
            variant="success"
            onClick={() =>
              arrayHelpers.push({
                config: {
                  webinar_title: '',
                  datetime: '',
                  datetime_timezone: '',
                },
              })
            }
          >
            + Webinar
          </Button>
        )}
    </>
  );
};

export default WebinarForm;
